import mustache from "mustache";
import { AplicacionRequest } from "../../../../modulos/aplicaciones/request/AplicacionRequest";
import { MetodoAplicacion } from "../../../../modulos/aplicaciones/response/AplicacionResponse";
import { IConnectRender } from "../../../definitions/IConnectRender";
import template from "./aplicacionMetodoTemplate.html";

mustache.parse(template);

/** Contador incremental de instancias, para no colisionar ids en el DOM. */
let METODO_ID = 0;

/** Los cinco métodos, en el orden del mockup: el dron primero —es el que el
 *  módulo registró siempre— y después los manuales. El ícono es de Phosphor,
 *  que ya está cargado en la app. */
const METODOS: { id: MetodoAplicacion; nombre: string; icono: string }[] = [
  { id: "dron", nombre: "Dron", icono: "ph-drone" },
  { id: "estacionaria", nombre: "Estacionaria", icono: "ph-engine" },
  { id: "espalda", nombre: "Espalda", icono: "ph-backpack" },
  { id: "tractor", nombre: "Tractor", icono: "ph-tractor" },
  { id: "drench", nombre: "Drench", icono: "ph-drop" },
];

/** Selector del método de aplicación: una fila de chips sobre el formulario.
 *
 *  No es un `IFormField` porque no tiene nada que validar —siempre hay un método
 *  elegido— pero sí decide qué campos muestra el resto del formulario, así que
 *  avisa por `onChange` en vez de escribir el request en silencio.
 *
 *  Chips y no un `<select>`: son cinco opciones fijas que cambian el formulario
 *  entero, y conviene verlas todas a la vez para entender que son excluyentes. */
export class AplicacionMetodoField implements IConnectRender {
  /** Id de instancia, para los ids del DOM. */
  private readonly _id: number = ++METODO_ID;

  /**
   * @param _request  Request que se está editando (fuente de verdad del método).
   * @param _onChange Avisa que cambió, para que el formulario se rearme.
   */
  constructor(
    private readonly _request: AplicacionRequest,
    private readonly _onChange: (metodo: MetodoAplicacion) => void,
  ) {}

  render(): string {
    return mustache.render(template, {
      id: this._id,
      metodos: METODOS.map((metodo) => ({
        ...metodo,
        activo: metodo.id === this._request.metodo,
      })),
    });
  }

  connect(): void {
    this._contenedor = document.getElementById(`apMetodos-${this._id}`);
    this._contenedor?.addEventListener("click", this._onClick);
  }

  dispose(): void {
    this._contenedor?.removeEventListener("click", this._onClick);
    this._contenedor = null;
  }

  /** Deshabilita los chips mientras se guarda, igual que el resto de los
   *  campos. */
  setDisabled(disabled: boolean): void {
    this._contenedor
      ?.querySelectorAll<HTMLButtonElement>("button")
      .forEach((boton) => {
        boton.disabled = disabled;
      });
  }

  private _contenedor: HTMLElement | null = null;

  private _onClick = (event: Event): void => {
    const chip = (event.target as HTMLElement).closest<HTMLElement>(
      "[data-metodo]",
    );
    if (!chip) return;

    const metodo = chip.dataset.metodo as MetodoAplicacion;
    if (metodo === this._request.metodo) return;

    this._request.metodo = metodo;
    this._marcarActivo(metodo);
    this._onChange(metodo);
  };

  /** Mueve la marca de activo sin repintar la fila: repintarla perdería el foco
   *  y haría parpadear los íconos. */
  private _marcarActivo(metodo: MetodoAplicacion): void {
    this._contenedor
      ?.querySelectorAll<HTMLElement>("[data-metodo]")
      .forEach((chip) => {
        chip.classList.toggle("ap-metodo--activo", chip.dataset.metodo === metodo);
      });
  }
}
